import { render, staticRenderFns } from "./PageEvaluate.vue?vue&type=template&id=65ad1960&scoped=true&"
import script from "./PageEvaluate.vue?vue&type=script&lang=js&"
export * from "./PageEvaluate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad1960",
  null
  
)

export default component.exports